import { h, Fragment } from 'preact'
import { isMobile } from '../../js/modules/utilities.js'

import mastheadTopImg from './placeholder.png'

export const Publicite = (props) => {
   return <Fragment>{isMobile() ? <PubliciteMobile {...props} /> : <PubliciteDesktop {...props} />}</Fragment>
}

const PubliciteMobile = ({ adsId, type }) => {
   if (type === 'masthead1') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="ad-with-border">
            <div id="ad1" style="height:0; overflow: hidden; width:320px; margin: 0 auto;">
               <div class="tag-masthead">
                  <div id={adsId} class="text-center"></div>
               </div>
            </div>
         </div>
      )
   } else if (type === 'masthead2') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="ad-with-border pt-2 mb-2">
            <div id="ad2" style="height:0; overflow: hidden; width:320px; margin: 0 auto;">
               <div class="tag-masthead">
                  <div id={adsId} class="text-center"></div>
               </div>
            </div>
         </div>
      )
   } else if (type === 'native') {
      return <div id={adsId} data-testid="bande-pub-native"></div>
   }
}

const PubliciteDesktop = ({ adsId, analytics, URL, type }) => {
   if (type === 'mastheadTop') {
      document.documentElement.style.setProperty('--img-masthead-top', `url(${mastheadTopImg})`)

      return (
         <div class="mastheadTop-wrapper">
            <div id={adsId} class="mastheadTop"></div>
            <a
               href={URL}
               data-pdb-zid={analytics.pdbZid}
               data-oevent-category={analytics.oeventCategory}
               data-oevent-action={analytics.oeventAction}
               data-oevent-label={analytics.oeventLabel}
               data-oevent-other={analytics.oeventOther}
               class="mastheadTopLink"
            >
               <img src={mastheadTopImg} alt="Le meilleur du black friday avec orange" />
            </a>
         </div>
      )
   } else if (type === 'masthead1') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="container-fluid">
            <div id="ad" style="height:0; overflow: hidden;" class="mx-auto mb-1" data-testid="bande-masthead">
               <div id={adsId} class="tag-masthead mt-2 text-center"></div>
            </div>
         </div>
      )
   } else if (type === 'lienscommerciaux') {
      return (
         <div class="container-fluid">
            <div id={adsId} class="mb-4" widget-id="SF_1" data-testid="bande-liens-commerciaux"></div>
         </div>
      )
   } else {
      let params = {}
      switch (type) {
         case 'rm':
            params = {
               class: 'tag-rm',
               'data-testid': 'pub-rm',
            }
            break
         case 'native':
            params = {
               class: 'tag-native',
               'data-testid': 'pub-native',
            }
            break
      }
      return <div id={adsId} {...params}></div>
   }
}
